import BattlecardHeader from "./battlecard-header";

export default function BattlecardHeaderLayout({ children }) {
  return (
    <div className="bc-battlecard-header-layout">
      <BattlecardHeader />
      {children}
    </div>
  );
}
